/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorReferentialItem } from './ActorReferentialItem';
import {
    ActorReferentialItemFromJSON,
    ActorReferentialItemFromJSONTyped,
    ActorReferentialItemToJSON,
    ActorReferentialItemToJSONTyped,
} from './ActorReferentialItem';

/**
 * 
 * @export
 * @interface GetActorReferentialResponse
 */
export interface GetActorReferentialResponse {
    /**
     * 
     * @type {number}
     * @memberof GetActorReferentialResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<ActorReferentialItem>}
     * @memberof GetActorReferentialResponse
     */
    items: Array<ActorReferentialItem>;
}

/**
 * Check if a given object implements the GetActorReferentialResponse interface.
 */
export function instanceOfGetActorReferentialResponse(value: object): value is GetActorReferentialResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetActorReferentialResponseFromJSON(json: any): GetActorReferentialResponse {
    return GetActorReferentialResponseFromJSONTyped(json, false);
}

export function GetActorReferentialResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetActorReferentialResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(ActorReferentialItemFromJSON)),
    };
}

export function GetActorReferentialResponseToJSON(json: any): GetActorReferentialResponse {
    return GetActorReferentialResponseToJSONTyped(json, false);
}

export function GetActorReferentialResponseToJSONTyped(value?: GetActorReferentialResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(ActorReferentialItemToJSON)),
    };
}

